var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: ["ft-input-wrap", _vm.wrapClass] },
    [
      _vm.type === "textarea"
        ? _c("textarea", {
            class: ["ft-input", _vm.inputClass],
            attrs: {
              type: _vm.type,
              maxlength: _vm.maxlength,
              placeholder: _vm.placeholder,
              disabled: _vm.disabled,
              readonly: _vm.readonly
            },
            domProps: { value: _vm.value },
            on: { input: _vm.onInput }
          })
        : _c("input", {
            class: ["ft-input", _vm.inputClass],
            attrs: {
              type: _vm.type,
              maxlength: _vm.maxlength,
              placeholder: _vm.placeholder,
              disabled: _vm.disabled,
              readonly: _vm.readonly
            },
            domProps: { value: _vm.value },
            on: { input: _vm.onInput }
          }),
      _vm._v(" "),
      _c("ft-close-icon", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.calcShowClose,
            expression: "calcShowClose"
          }
        ],
        staticClass: "icon-clear",
        on: { clear: _vm.onClear }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-69260124", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-69260124","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/base/ftInput.vue
// module id = null
// module chunks = 